/* global define */

define([], () => ({

  RESIZE_MODAL: 'RESIZE_MODAL',

  UPDATE_ANALYTICS_SETTING: 'UPDATE_ANALYTICS_SETTING',

  REQUEST_OVERVIEW: 'REQUEST_OVERVIEW',
  UPDATE_OVERVIEW: 'UPDATE_OVERVIEW',
  RECEIVE_OVERVIEW: 'RECEIVE_OVERVIEW',
  ERROR_OVERVIEW: 'ERROR_OVERVIEW',

  RECEIVE_FORMS: 'RECEIVE_FORMS',
  REQUEST_FORMS: 'REQUEST_FORMS',
  SORT_FORMS: 'SORT_FORMS',
  ERROR_FORMS: 'ERROR_FORMS',
  RECEIVE_FORM: 'RECEIVE_FORM',
  REQUEST_FORM: 'REQUEST_FORM',

  // A universal action called on all requests.
  VALIDATE: 'VALIDATE',
}));

